import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import LoaderBlock from '../LoaderBlock';
import { translate } from 'react-polyglot';
import BookReader from '../BookReader';
import HorizontalGrid from '../HorizontalGrid';
import BookCard from '../BookCard';
import SvgIcon from '../SvgIcon';
import Tags from '../Book/Tags';
import Button from '../Button';
import ShareMenu from '../ShareMenu';
import FloatingActionsBar from '../FloatingActionsBar';
import LazyLoad from 'react-lazyload';
import Bookmark from './../StemCard/Bookmark'
import Breadcrumb from './../Breadcrumb';
import StoryVideo from '../Book/StoryVideo';
import VideoCard from '../VideoCard';
import { getLessonPlanDataWorkFlow, getLpStaticDataWorkFlow } from '../../redux/stemActions';
import { fetchBookAssetsWorkflow, resetSuggestions, fetchBookWorkflow, openGlobalBookReader, closeGlobalBookReader } from '../../redux/bookActions';
import {fetchUserListsWorkflow, openAuthModal} from '../../redux/userActions';
import {getBookMarksWorkFlow, addLPViewsWorkFlow} from '../../redux/stemActions';
import { enablePortraitViewMessage, disablePortraitViewMessage } from '../../redux/portraitViewMessageActions';
import './LessonPlanContainer.scss';
import LPSectionCard from '../LPSectionCard/LPSectionCard';
import { lpImages, stemImages, subjectsStem, userAuthStages, links, gaEventCategories, MAX_OFFLINE_BOOKS_COUNT,emergentReaderLevel, gaEventLabel, gaEventActions, sanitizeHref } from '../../lib/constants';
import { loginPolicy } from '../../lib/policymanager/index';
import { openVideoPlayer, closeVideoPlayer, } from '../../redux/bookActions';
import ErrorPage from '../ErrorPage';
import OfflineActions from '../Book/OfflineActions';
import {
  saveOfflineWorkflow,
  unsaveOfflineWorkflow,
  isAvailableOffline,
  getOfflineBooksCountForList
} from '../../redux/offlineBooksActions';
import { addSlimNotification } from '../../redux/slimNotificationActions';
import { getImageSize } from '../../lib/images';
import NoSpaceForMoreOfflineBooksModal from '../Book/NoSpaceForMoreOfflineBooksModal';
import DeleteModal from '../Book/DeleteModal';
import { isRtlLanguage } from '../../lib/appHelpers';

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('language') || 'en';

const mapStateToProps = ({ viewport, stem, book, windowDimensions, user, offlineBooks, network  }) => ({
  viewport,
  offlineBooks,
  isLoggedIn: user.isLoggedIn,
  isFetchingMe: user.isFetchingMe,
  online: network.online,
  userId: user.profile.id,
  userType: user.profile.profile_type,
  userRoles: user.profile.roles,
  lpData: stem.lpData,
  bookAssets: book.assets,
  book: book,
  windowDimensions: windowDimensions,
  lpStaticData: stem.lpStaticData,
  isVideoPlayerVisible: book.isVideoPlayerVisible,
  isFetchingAssets: book.isFetchingAssets
})

const mapDispatchToProps = {
  getLessonPlanDataWorkFlow,
  getLpStaticDataWorkFlow,
  fetchBookAssetsWorkflow,
  disablePortraitViewMessage,
  enablePortraitViewMessage,
  resetSuggestions,
  fetchBookWorkflow,
  openGlobalBookReader,
  closeGlobalBookReader,
  fetchUserListsWorkflow, 
  getBookMarksWorkFlow,
  addLPViewsWorkFlow,
  openAuthModal,
  openVideoPlayer,
  closeVideoPlayer,
  saveOfflineWorkflow,
  unsaveOfflineWorkflow,
  addSlimNotification
}

const LessonPlanContainer = ( {parentClassName, online, match, getLessonPlanDataWorkFlow, addLPViewsWorkFlow, lpData, fetchBookAssetsWorkflow, fetchBookWorkflow, windowDimensions, disablePortraitViewMessage, enablePortraitViewMessage, userId, userType, userRoles, isLoggedIn, viewport, resetSuggestions, t, lpStaticData, getLpStaticDataWorkFlow, openGlobalBookReader, closeGlobalBookReader, openAuthModal, getBookMarksWorkFlow, fetchUserListsWorkflow, openVideoPlayer, closeVideoPlayer, isFetchingAssets, isVideoPlayerVisible, saveOfflineWorkflow, offlineBooks, unsaveOfflineWorkflow, addSlimNotification, isFetchingMe} ) => {
  const baseClassName = 'pb-lesson-plan-container';
  const isRtl = isRtlLanguage(lang);

  const classes = {
    [baseClassName]: true,
    [parentClassName]: parentClassName,
    [`${baseClassName}--rtl`]: isRtl
  };


  const descrptnClasses = {
    [`${baseClassName}__descrptn`]: true,
    [`${baseClassName}__descrptn--rtl`]: isRtl
  };

  const ytvideoClasses = {
    [`${baseClassName}__yt-video`]: true,
    [`${baseClassName}__video-card`]: true,
    [`${baseClassName}__yt-video--rtl`]: isRtl
  };

  const iconClasses = {
    [`${baseClassName}__icon`]: true,
    [`${baseClassName}__icon--rtl`]: isRtl
  };

  const subClasses = {
    [`${baseClassName}__sub-title`]: true,
    [`${baseClassName}__sub-title--rtl`]: lang !== 'en'
  };

  const [activeContent, setActiveContent] = useState("introduction")
  const [activeIndex, setActiveIndex] = useState(0)
  const [showSection, setShowSection] = useState(false)
  const [subMenu, setSubMenu] = useState(false);
  const [video, setVideo] = useState(null);
  const [showBtn, setBtn] = useState(false);

  const [activityBookData, setActivityBookData] = useState([])
  const [activityBookAssets, setActivityBookAssets] = useState([])

  const [moreBookData, setMoreBookData] = useState([])
  const [moreBookAssets, setMoreBookAssets] = useState([])
  const [isSavingOffline, setIsSavingOffline] = useState(false)
  const [activeChunk, setActiveChunk] = useState([])
  const [isModalVisible, setIsModalVisible] = useState({noSpaceForMoreOfflineBooks: false, delete: false})

  useEffect(() => {
    getLessonPlanDataWorkFlow(match.params.id)
    getLpStaticDataWorkFlow(lang)
  }, [])

  const prevRef = useRef();
  useEffect(() => {
    prevRef.current = isFetchingMe
  })

  const prevFetchMe = prevRef.current

  useEffect(() => {
    if(prevFetchMe && prevFetchMe !== isFetchingMe && !isFetchingMe && !isLoggedIn && online) {
      let stemCardClickCount = parseInt((localStorage.getItem("stemCard-click-count")),10) || 0;
      stemCardClickCount++;
      localStorage.setItem("stemCard-click-count", stemCardClickCount.toString());

      if(stemCardClickCount > 1) openAuthModal({
        hideClose: true
      });
    }
  }, [isFetchingMe])

  useEffect(() => {
    if(isLoggedIn) {
      getBookMarksWorkFlow(userId)
      fetchUserListsWorkflow()
    }
  }, [isLoggedIn, openAuthModal])

  useEffect(()=> {
    if(lpData) {
      if(isLoggedIn) addLPViewsWorkFlow(userId, lpData.id)
      let x = lpData.attributes.activity;
      if(x.length > 0) {
        let requests = x.map(el => {
          if(el.bookId) {
            return fetchBookAssetsWorkflow(el.bookId, false, false, false, false, true)   

          }
          else return null
        })

        Promise.all(requests).then((body) => { 
          body.forEach(res => {
            if (res && res.ok) {
              activityBookAssets.push(res.data)
              setActivityBookAssets([...activityBookAssets])
            }
            else {
              activityBookAssets.push(null)
              setActivityBookAssets([...activityBookAssets])
            }
          })
        })

        let bookRequests = x.map(el => {
          if(el.bookId) {
            return fetchBookWorkflow(el.bookId)           
          }
          else return null
        })

        Promise.all(bookRequests).then((body) => { 
          body.forEach(res => {
            if (res && res.ok) {
              if(activityBookData.filter(el => el.id === res.data.id).length <= 0) {
                activityBookData.push(res.data)
                setActivityBookData([...activityBookData])
              }
            }
          })
        })

      }

      let y = lpData.attributes.moreStories;
      if(y) {
        let requests = y.story.map(el => {
          if(el.bookId) {
            return fetchBookAssetsWorkflow(el.bookId, false, false, false, false, true)           
          }
          else return null
        })

        Promise.all(requests).then((body) => { 
          body.forEach(res => {
            if (res.ok) {
              moreBookAssets.push(res.data)
              setMoreBookAssets([...moreBookAssets])
            }
            else {
              moreBookAssets.push(null)
              setMoreBookAssets([...moreBookAssets])
            }
          })
        })
        .then(() =>  setBtn(true))


        let bookRequests = y.story.map(el => {
          if(el.bookId) {
            return fetchBookWorkflow(el.bookId)           
          }
          else return null
        })

        Promise.all(bookRequests).then((body) => { 
          body.forEach(res => {
            if (res && res.ok) {
              if(moreBookData.filter(el => el.id === res.data.id).length <= 0) {
                moreBookData.push(res.data)
                setMoreBookData([...moreBookData])
              }
            }
          })
        })

      }
      else {
        setBtn(true)
      }
    }
  }, [lpData])

  const contentClasses = {
    [`${baseClassName}__content`]: true,
    [`${baseClassName}__offline`]: !online
  };

  const offlineClasses = {
    [`${baseClassName}__actions-item`]: true,
    [`${baseClassName}__actions-item--offline`]: true,
    [`${baseClassName}__actions-item--disabled`]: !showBtn,
  };

  if(!lpData || !lpStaticData) return <LoaderBlock />

  let stemLPTags = [];
  const {name, subject, grade, learnings, LPTags, introduction, activity, vocabulary, projectIdea, questionAnswers, moreStories, commonMisconceptions, hots, everydayExample, addonResource, locale } = lpData.attributes;

  if (LPTags.length > 0) {
    LPTags.forEach(el => {
      if (!stemLPTags.map(el => el && el.tagName.toLowerCase()).includes(el.tagName.toLowerCase())) {
        stemLPTags.push(el);
      }
    });
  }

  let sub;
  if(subject === "EVS") sub = "science"
  if(subject === "Maths") sub = "maths"


  if(sub !== match.params.subject){
    return <ErrorPage showErrorText/>
  }

  const getVideoId = (link) => {
    let url = new URL(link);
    let id = url.searchParams.get('v');
    return id;
  }

  const onReadClicked = (book) => {
  
    if(process.env.REACT_APP_FEATURE_MANDATORY_LOGIN) {
      if (loginPolicy.shouldShowMandatoryLogin()) {
        openAuthModal({
          stage: userAuthStages.mandatoryLogin
        })
      } else {
        fetchBookAssetsWorkflow(book.slug, book.isAudio, false, false, false, true)
          .then(()=>{
            openGlobalBookReader({book, readSource: "stem"})
        })
        loginPolicy.storyRead(book.slug);
      }
    }
  }  
  
  const onPlayVideoClicked = (id, videoName) => {
    setVideo(id)
    openVideoPlayer();
    triggerEvents({
      gaAction: `clicked_video`,
      gtmLabel: 'additional_resources',
      itemType:'video_name', 
      itemId: lpData.id, 
      itemValue: videoName
    })
  }
  
  const onCloseVideo = () => {
    closeVideoPlayer()
  }

  const onShareClicked = (shareType) => {
    triggerEvents({
      gaAction: `clicked_${shareType.substr(5).toLowerCase()}`,
      gtmLabel: 'share_this_page',
      itemType:'grade,lesson_plan', 
      itemId: lpData.id, 
      itemValue: `${grade}_${name}`
    })
  }

  const triggerEvents = (obj) => {
    const { gaAction,gtmLabel, itemType, itemValue, itemId} = obj;

    window.dataLayer.push({
      'category': gaEventCategories.stemLp,
      ...(gtmLabel && { 'label': gtmLabel }),
      ...(gaAction && { 'event': gaAction }),
      'item_type': itemType || null,
      'item_id': itemId || null,
      'item_value': itemValue || null,
      'user_profile': userType,
      'user_id': userId || '00000'
    })
  }

  const displayReader = (id, book, type, index) => {
      if(book) return <BookReader 
        pages={book.pages}
        cssHref={book.css}
        viewport={viewport}
        orientation={book.orientation}
        isLoggedIn={isLoggedIn}
        language={book.language}
        level={book.level}
        userRoles={userRoles}
        userId={userId}
        onScrollPages={() => triggerEvents({
          gaAction: gaEventActions.startReading,
          gtmLabel: type === "reading_discovering" ? `${lpData.id}_${grade}_keep_reading` : `${lpData.id}_${grade}_${index}`,
          itemType:'book', 
          itemId: id, 
          itemValue: book.slug
        })}
        windowDimensions={windowDimensions}
        assets={book}
        slug={book.slug}
        book={book}
        t={t}
        startPage={1}
        lp
        small
        hideClose
        id={id}
        enablePortraitViewMessage={enablePortraitViewMessage}
        disablePortraitViewMessage={disablePortraitViewMessage}
        closeGlobalBookReader={closeGlobalBookReader}
        resetSuggestions={resetSuggestions}
        hideRotatePopup
        //isRtl={isRtl}
      /> 
 }

  let introSection = (data) => <div>
    {data.teacherSay && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.teacherSay}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.teacherSay)}}></div>
    </div>}
    {data.teacherDo && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.teacherDo}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.teacherDo)}}></div>
    </div> }
    {data.teacherNotes && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.teacherNotes}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.teacherNotes)}}></div>
    </div> }  
  </div>

  let activitySection = (data, ind) => <div>
    {
      activityBookAssets.length > 0 && activityBookAssets[ind] && displayReader(data.bookId, activityBookAssets[ind], `activity_${ind+1}`, ind+1)
    }
    {data.objective && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.objective}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.objective)}}></div>
    </div>}
    {data.description && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.description}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.description)}}></div>
    </div>}
    {data.materialsRequired && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.materialsRequired}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.materialsRequired)}}></div>
    </div>}
    {data.expectedOutcome && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.expectedOutcome}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.expectedOutcome)}}></div>
    </div>}
    {data.teacherNotes && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.teacherNotes}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.teacherNotes)}}></div>
    </div>}
    {data.optionalIdeas && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.optionalIdeas}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.optionalIdeas)}}></div>
    </div>}
    {data.optionalActivity && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.optionalActivity}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.optionalActivity)}}></div>
    </div>}
    {data.discussion && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.discussion}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.discussion)}}></div>
    </div>}
    {data.reflection && <div className={`${baseClassName}__inline-section`}>
      <p className={`${baseClassName}__head`}>{lpStaticData.reflection}</p>
      <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(data.reflection)}}></div>
    </div>}
  </div>

  let vocabSection = (data) => <div className={`${baseClassName}__vocab-section`}>
    {data.map(el => {
      return(
        <div className={`${baseClassName}__vocab-box`}>
          <p className={`${baseClassName}__word`}>{el.word}</p>
          <div className={`${baseClassName}__definition`} dangerouslySetInnerHTML={{__html: sanitizeHref(el.description)}}></div>
        </div>
      );
    })}
  </div>

  let moreSection = (data) => <div>
  {data && data.story.length > 0 && data.story.map((el, ind)=> {
    return(
      <div className={`${baseClassName}__section`} key={ind}>
        {
          moreBookAssets.length > 0 && moreBookAssets[ind] && displayReader(el.bookId, moreBookAssets[ind], "reading_discovering", ind+1)
        }
        <div className={!online ? `${baseClassName}__offline ${baseClassName}__content ${baseClassName}__content-bold` : `${baseClassName}__content ${baseClassName}__content-bold`} dangerouslySetInnerHTML={{__html: sanitizeHref(el.bookDescription)}}></div>
      </div>
    );
  })}
  </div>

  let examplesSection = (data) => <div>
    {data.map(el => {
      return(
        <div className={`${baseClassName}__section ${baseClassName}__section-img`}>
          {el.imageUrl && <LazyLoad offset={100} once>
            <img 
              src={el.imageUrl}
              alt={'example'} 
              className={`${baseClassName}__image`}
              />
          </LazyLoad>}
          <div className={`${classNames(contentClasses)} ${classNames(descrptnClasses)}`} dangerouslySetInnerHTML={{__html: sanitizeHref(el.description)}}></div>
        </div>
      );
    })}
    </div>

  let qaSection = (data) => <div>
  {data.map(el => {
    return(
      <div className={`${baseClassName}__qa-section`}>
        <p className={`${baseClassName}__question`}>{el.question}</p>
        <div className={classNames(contentClasses)} dangerouslySetInnerHTML={{__html: sanitizeHref(el.answer)}}></div>
      </div>
    );
  })}
  </div>

  let addonSection = (data) => <div>
  {data.map((el, ind)=> {
    return(
      <div className={`${baseClassName}__section`}>
        <div className={`${baseClassName}__yt-section`}>
          <div className={`${classNames(ytvideoClasses)}`}>
            {/* <YoutubeVideoEmbed videoId={getVideoId(el.youtubeLink)} allowFullScreen /> */}
            <VideoCard 
              key={ind}
              videoId={el.youtubeLink}
              hasOverlay
              onClick={() => onPlayVideoClicked(getVideoId(el.youtubeLink), el.description)}
            />
          </div>
          <div className={`${baseClassName}__yt-desc`}>
            <p className={`${baseClassName}__yt-title`}>{el.description}</p>
            <p className={`${baseClassName}__yt-attr`}>{el.attribution}</p>
          </div>
        </div>
      </div>
    );
  })}
  </div>

  let misconceptSection = (data) => <div>
  {data.map(el => {
    return(
      <div className={`${baseClassName}__watchout-sec ${baseClassName}__section`}>
        <div>
        <p className={`${baseClassName}__wrong`}><SvgIcon parentClassName={classNames(iconClasses)} name="wrong" size="sm"/>{el.wrong}</p>
        </div>
        <div>
        <p className={`${baseClassName}__right`}><SvgIcon parentClassName={classNames(iconClasses)} name="profile-completion-check" size="sm"/>{el.correct}</p>
        </div>
      </div>
    );
  })}
  </div>

  const scrollTo = (id, ind) => {
    if(!viewport.medium) {
      setActiveIndex(ind); 
      setShowSection(true);
      document.getElementsByClassName("pb-site-footer")[0].style.display = 'none'
      window.scrollTo(0,0);
    }
    const el = document.getElementById(id);
    if (el) {
      setActiveContent(id)
      window.scrollTo({ top: el.offsetTop - 150, behavior: 'smooth' });
    }
  }

  const launchSection = () => {
    window.scrollTo(0,0)
    setActiveIndex(0)
    setShowSection(true)
    document.getElementsByClassName("pb-site-footer")[0].style.display = 'none'
  }

  const handleClose = () => {
    setShowSection(false); 
    setSubMenu(false)
    document.getElementsByClassName("pb-site-footer")[0].style.display = ''
  }

  const changeSection = (ind) => {
    setActiveIndex(activeIndex+ind)
    window.scrollTo(0,0)
  }

  let contentArray = [
    introduction ? {
      id: "introduction",
      action: "clicked_introduce_book",
      content: lpStaticData.introHeading
    } : [],
    ...(activity.length > 0 ? activity.map((el, ind) => {
      return {
        id: `activity${ind+1}`,
        action: `clicked_activity_${ind+1}`,
        content: `${lpStaticData.activityCurved} ${ind+1}`
      }
    }) : []),
    vocabulary.length > 0 ? {
      id: "vocabulary",
      action: "clicked_new_words",
      content: lpStaticData.vocabHeading
    } : [],
    ...(projectIdea.length > 0 ? projectIdea.map((el, ind) => {
      return {
        id: `projectIdea${ind+1}`,
        action: `clicked_project_${ind+1}`,
        content: `${lpStaticData.projectIdeaCurved} ${ind+1}`
      }
    }) : []),
    moreStories && moreStories.story.length > 0 ? {
      id: "moreStories",
      action: "clicked_keep_reading",
      content: lpStaticData.moreStoriesHeading
    }: [],
    commonMisconceptions.length > 0 ? {
      id: "misconceptions",
      action: "clicked_watch_out_for",
      content: lpStaticData.misconceptionsHeading
    } : [],
    questionAnswers.length > 0 ? {
      id: "questions",
      action: "clicked_story_lead",
      content: lpStaticData.questionsHeading
    } : [],
    hots.length > 0 ? {
      id: "hots",
      action: "clicked_hots",
      content: lpStaticData.hotsHeading
    } : [],
    everydayExample.length > 0 && online ? {
      id: "examples",
      action: "clicked_look_around",
      content: lpStaticData.everydayExamplesHeading
    } : [],
    addonResource.length > 0 && online ? {
      id: "addons",
      action: "clicked_add_resources",
      content: lpStaticData.addonsHeading
    } : [],
  ].flat()

  let footer = <div className={`${baseClassName}__footer-card`}>
    <div dangerouslySetInnerHTML={{__html: sanitizeHref(lpStaticData.footer)}}></div>
  </div>

  let sectionArray = [
    introduction ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.introHeading} 
      bgColor={"linear-gradient(102.44deg, #FFF5DB 8.98%, #FFE7C6 90.64%)"}
      textColor={"#A0680C"}
      image={lpImages.intro} 
      subHeading={lpStaticData.introSubheading}
      content={introSection(introduction)}
      id="introduction"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    ...(activity.length > 0 ? activity.map((el, ind) => <LPSectionCard 
      sectionTitle={`${lpStaticData.activityCurved} ${ind+1}`}
      title={ind === 0 ? lpStaticData.activity1Heading : lpStaticData.activity2Heading} 
      bgColor={"linear-gradient(283.64deg, #F7E3F0 -9.96%, #FFF0EC 116.83%)"}
      textColor={"#A05572"}
      image={lpImages.activity} 
      subHeading={null}
      content={activitySection(el, ind)}
      id={`activity${ind+1}`}
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    />) : []),
    vocabulary.length > 0 ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.vocabHeading} 
      bgColor={"linear-gradient(100.98deg, #E3F2FF 2.57%, #C4E2FC 108.19%)"}
      textColor={"#4C677D"}
      image={lpImages.vocab} 
      subHeading={lpStaticData.vocabSubheading}
      content={vocabSection(vocabulary)}
      id="vocabulary"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    ...(projectIdea.length > 0 ? projectIdea.map((el, ind) => <LPSectionCard 
      sectionTitle={`${lpStaticData.projectIdeaCurved} ${ind+1}`}
      title={el.name} 
      bgColor={"linear-gradient(278.98deg, #ECE3FF -6.85%, #FBF5FF 111.35%)"}
      textColor={"#775AA9"}
      image={lpImages.project} 
      subHeading={null}
      content={el.projectDetails && activitySection(el.projectDetails)}
      id={`projectIdea${ind+1}`}
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    />) : []),
    moreStories && moreStories.story.length > 0 ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.moreStoriesHeading} 
      bgColor={"linear-gradient(278.95deg, #EED3B5 -44.52%, #FFEBD8 100.55%)"}
      textColor={"#796957"}
      image={lpImages.more} 
      subHeading={null}
      content={moreSection(moreStories)}
      id="moreStories"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    commonMisconceptions.length > 0 ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.misconceptionsHeading} 
      bgColor={"linear-gradient(107.04deg, #F4FEE6 -9.1%, #DFF1CC 109.11%)"}
      textColor={"#68755A"}
      image={lpImages.misconcept} 
      subHeading={lpStaticData.misconceptionsSubHeading}
      content={misconceptSection(commonMisconceptions)}
      id="misconceptions"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    questionAnswers.length > 0 ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.questionsHeading} 
      bgColor={"linear-gradient(100.98deg, #E3F2FF 2.57%, #C4E2FC 108.19%)"}
      textColor={"#4C677D"}
      image={lpImages.qa} 
      subHeading={lpStaticData.questionsSubheading}
      content={qaSection(questionAnswers)}
      id="questions"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    hots.length > 0 ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.hotsHeading} 
      bgColor={"linear-gradient(101.22deg, #FAF8DC 2.62%, #E5E4D2 130.01%)"}
      textColor={"#7D7A53"}
      image={lpImages.hots} 
      subHeading={lpStaticData.hotsSubheading}
      content={qaSection(hots)}
      id="hots"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    everydayExample.length > 0 && online ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.everydayExamplesHeading} 
      bgColor={"linear-gradient(100.98deg, #EDFFDB 2.57%, #E3FFE6 108.19%)"}
      textColor={"#66845D"}
      image={lpImages.example} 
      subHeading={lpStaticData.everydayExamplesSubheading}
      content={examplesSection(everydayExample)}
      id="examples"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : [],
    addonResource.length > 0 && online ? <LPSectionCard 
      sectionTitle={null}
      title={lpStaticData.addonsHeading} 
      bgColor={"linear-gradient(100.98deg, #DFE5FF 2.57%, #E4E0FF 83.67%)"}
      textColor={"#6A6E8F"}
      image={lpImages.addon} 
      subHeading={lpStaticData.addonsSubheading}
      content={addonSection(addonResource)}
      id="addons"
      viewport={viewport}
      footer={footer}
      onClose={handleClose}
      online={online}
      isRtl={isRtl}
    /> : []
  ].flat()


  let spotlightBook = (book) => <div className={`${baseClassName}__contents-section ${baseClassName}__book-section`}>
    <p className={classNames(subClasses)}>{lpStaticData.booksUsedWithTopic}</p>
    <div className={`${baseClassName}__book-detail`}>
      <BookCard 
        key={book.id} 
        book={book}
        hideMenu
        hideQuickViewBtn={true}
        hideAllIcons = {true}
        readSource={"stem"}
        originalAuthors={book.original_authors}
        isRtl={isRtl}
      />
      <div className={isRtl ? `${baseClassName}__book-desc--rtl ${baseClassName}__book-desc` : `${baseClassName}__book-desc`}>
        <p className={classNames(subClasses)}>{book.name}</p>
        <p className={`${baseClassName}__book-syn`} title={book.description}>{book.description}</p>
        <Button
          fullWidth
          label={lpStaticData.readStory}
          loading={isFetchingAssets}
          disabled={!showBtn}
          variant="primary"
          onClick={() => {onReadClicked(book); triggerEvents({
            gaAction: gaEventActions.startReading,
            gtmLabel: `${lpData.id}_${grade}_overview`,
            itemType: gaEventLabel.bookLangLevel, 
            itemId: book.id, 
            itemValue: `${book.language}_${book.level === "5" ? emergentReaderLevel.emergentReader : book.level}`,
          })}}
          isRtl={isRtl}
        />
      </div>
    </div>
  </div>

  let learningsSection = <div className={isRtl ? `${baseClassName}__learnings-section--rtl ${baseClassName}__learnings-section` : `${baseClassName}__learnings-section`}>
    <p className={classNames(subClasses)}>{lpStaticData.childLearnings}</p>
    <div className={`${baseClassName}__learnings`}>
     {learnings.map(el => <li className={`${baseClassName}__point`}>
       {
         isRtl ? <SvgIcon name="idea" pushLeft  size="m"/> : <SvgIcon name="idea" pushRight  size="m"/>
       }
        <span className={`${baseClassName}__point-text`}>{el.point}</span>
      </li>)
    }
    </div>
  </div>

  let isMath = subject.toLowerCase() === subjectsStem[0].toLowerCase();
  const profileId = userId || parseInt(localStorage.getItem('userId'), 10);


  const breadcrumbPaths = [{
    title: t('global.home'),
    href: links.home(),
    isInternal: false
  },
  {
    title: t('global.stem'),
    href: links.stemHome(lang),
    isInternal: false,
    isLast: true
  }];

  const onOpenModal = (modalName, arr) => {
    setIsModalVisible({
        [modalName]: true
    });

    if(arr) setActiveChunk(arr)
  }
  const onCloseModal = (modalName) => {
    setIsModalVisible({
      [modalName]: false
  });
  }

  const getCountAfterSave = (arr, lpId) => {
    const booksAvailableToSaveToOfflineForUser = arr.filter(lesson => userId && !isAvailableOffline(lesson.id, offlineBooks, 'stemHome', userId, lpId));
    const booksToBeSavedOffline = booksAvailableToSaveToOfflineForUser.filter(lesson => !isAvailableOffline(lesson.id, offlineBooks, 'stemHome', null, lpId)).length;
    const offlineTranslateBooksCountForUser = offlineBooks.translations.filter(translation => translation.userId === userId).length;
    const offlineReadBooksCountForUser = offlineBooks.books.filter(book => !book.isFromOfflineTranslate && book.savedUsers && book.savedUsers.includes(userId)).length;
    const offlineBooksCountForUser = offlineTranslateBooksCountForUser + offlineReadBooksCountForUser;
    const bookCountAfterSave = getOfflineBooksCountForList(offlineBooksCountForUser, booksAvailableToSaveToOfflineForUser.length, offlineBooks.books.length, booksToBeSavedOffline);
    return bookCountAfterSave
  }

  const hasSpaceForSave = (arr , lpData) => {
    let totalBytesNeeded = 0;
    let remainingBytes = 0;
    let currentOccupied= JSON.stringify(localStorage).length;
    let LSCapacity = 5000000;

    console.log("Current occupied ", currentOccupied)

    if(currentOccupied < LSCapacity) {
      return true
    }

    arr.forEach(lesson => {
          lesson.isFromStemHome = true;
          lesson.lpData = {
            id: lpData.id,
            attributes: {
              learnings: lpData.attributes.learnings,
              name: lpData.attributes.name,
              grade: lpData.attributes.grade,
              subject: lpData.attributes.subject
            }
          };
          lesson.learnings = lpStaticData.childLearnings;
          lesson.locale = lang;
          lesson.lpId = lpData.id;
          totalBytesNeeded+= JSON.stringify(lesson).length

    })
    console.log("Total bytes needed ", totalBytesNeeded)


    remainingBytes = LSCapacity - currentOccupied;
    console.log("Remaining bytes ", remainingBytes)

    if (totalBytesNeeded < remainingBytes ) return true
    return false

  }

  const onAddToOfflineClicked = (arr, lpData) => {
    if (getCountAfterSave(arr, lpData.id) > MAX_OFFLINE_BOOKS_COUNT) {
      return onOpenModal('noSpaceForMoreOfflineBooks')
    }
    else if(!hasSpaceForSave(arr, lpData)) {
      return onOpenModal('noSpaceForMoreOfflineBooks')
    }
    else {
      setIsSavingOffline(true);
      const saveBooksPromise = arr
        .map(lesson => {
          lesson.isFromStemHome = true;
          lesson.lpData = {
            id: lpData.id,
            attributes: {
              learnings: lpData.attributes.learnings,
              name: lpData.attributes.name,
              grade: lpData.attributes.grade,
              subject: lpData.attributes.subject
            }
          };
          lesson.learnings = lpStaticData.childLearnings;
          lesson.locale = lang;
          lesson.lpId = lpData.id;
          return  saveOfflineWorkflow(lesson, getImageSize(windowDimensions.width), userId, null, lpData.id )
        })
    
      Promise.all(saveBooksPromise).then(() => {
        setIsSavingOffline(false);
        addSlimNotification({
          type: 'info',
          content: lpStaticData.saveOfflineNotification
        })
        triggerEvents({
          gaAction: gaEventActions.saveOfflineLibrary,
          gtmLabel: lpData.id,
        })
        localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
  
      })
    }    
  }

  const onRemoveFromOfflineClicked = (arr) => {
    const profileId = userId || parseInt(localStorage.getItem('userId'), 10);
  
    const unsaveBooksPromise = arr
      .map(lesson => {
        const book = Object.assign({}, lesson, {isFromStemHome: true, lpId: lpData.id})
        return unsaveOfflineWorkflow(book, getImageSize(windowDimensions.width), profileId, lpData.id)
      })
  
    Promise.all(unsaveBooksPromise).then(() => {
      addSlimNotification({
        type: 'info',
        content: lpStaticData.removeOfflineNotification
      })
      triggerEvents({
        gaAction: gaEventActions.removeOfflineLibrary,
        gtmLabel: lpData.id,
      })
      localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
    })
  }

  const availableOffline = [...activityBookData, ...moreBookData].some(lesson => profileId && isAvailableOffline(lesson.id, offlineBooks, 'stemHome', profileId, lpData.id))
  //const stemHomeBooks = offlineBooks.filter(book => userId && book.savedUsers && book.isFromStemHome && book.savedUsers.includes(parseInt(userId, 10)))

  return (
    <div className={classNames(classes)}>
      {((!showSection && !viewport.medium) || viewport.medium) && <div className={`${baseClassName}__overview`}>
        {!viewport.medium && <div className={`${baseClassName}__banner`}>
          <img src={isMath ? stemImages.stemMathShadow : stemImages.stemScienceShadow} alt={'math'} className={`${baseClassName}__banner-image`}/>
          <img src={isMath? stemImages.stemMathBlue : stemImages.stemScienceOrange} alt={'math-shadow'} className={`${baseClassName}__banner-image`}/>
          <img src={isMath ? stemImages.stemMathLogo : stemImages.stemScienceLogo} alt={'mathIcon'} className={isRtl ? `${baseClassName}__banner-icon--rtl ${baseClassName}__banner-icon` : `${baseClassName}__banner-icon`}/>
        </div>}
        <Breadcrumb
          paths={breadcrumbPaths}
          parentClassName={`${baseClassName}__brd-crumb`}
          isRtl={isRtl}
        />
        <p className={`${baseClassName}__grade`}>{t('global.grade', {grade: grade.split(" ")[1]})}</p>
        <h1 className={`${baseClassName}__title`}>{name}</h1>
        <div className={`${baseClassName}__actions`}>
          {online &&
            <div className={`${baseClassName}__actions-item`}>
              {/* <SvgIcon name="share" pushRight size="sm"/> */}
              <ShareMenu href={window.location.href} viewport={viewport} align={isRtl ? "right" :"left"} showIconOnly={true} title={name} onClick={onShareClicked} isRtl={isRtl}/>
              <span>{lpStaticData.share}</span>
            </div>
          }
          {online &&
            <div className={`${baseClassName}__actions-item`}>
              <Bookmark lessonPlan={{id: lpData.id}} t={t} size="sm" bmText={lpStaticData.bookmark} bookmarkEvent={() => triggerEvents({
                          gtmLabel: 'bookmarked',
                          gaAction :'clicked_bookmark',
                          itemType:'grade,lesson_plan',
                          itemId: lpData.id,
                          itemValue: `${lpData.attributes.grade}_${lpData.attributes.name}`
                        })}
                        isRtl={isRtl} />
              <span>{lpStaticData.bookmark}</span>
            </div>
          }
          <div className={classNames(offlineClasses)}>
            <OfflineActions
              t={t}
              align={isRtl ? "left" : "right"}
              spacing='s'
              showIconOnly
              availableOffline={availableOffline}
              onClickAddToOffline={() => onAddToOfflineClicked([...activityBookData, ...moreBookData], lpData)}
              onClickRemoveFromOffline={() => onOpenModal('delete', [...activityBookData, ...moreBookData])}
              disabled={!('serviceWorker' in navigator)}
              isLoggedIn={isLoggedIn}
              openAuthModal={openAuthModal}
              isSavingOffline={isSavingOffline}
              saveOfflineText={"saveOffline"}
              deleteOfflineText={"deleteOffline"}
              rpOffline={true}
              loginText={t('global.please-log-in-add-topic-to-offline')}
              isRtl={isRtl}
            />
            <span className={availableOffline && `${baseClassName}__actions-item--color`}>{availableOffline ? lpStaticData.removeOffline : lpStaticData.saveOffline}</span>
          </div>
        </div>
        {!viewport.medium && activityBookData.length > 0 && spotlightBook(activityBookData[0])}
        {!viewport.medium && learningsSection}
        <div className={`${baseClassName}__contents-section`}>
          <p className={classNames(subClasses)}>{lpStaticData.contents}</p>
          <div className={`${baseClassName}__contents`}>
            {contentArray.map((el, ind) => {
              return <p className={activeContent === el.id && viewport.medium && `${baseClassName}__content--active`} 
              onClick={() => {scrollTo(el.id, ind); triggerEvents({
                gaAction: el.action,
                gtmLabel: 'side_menu',
                itemType:'grade,lesson_plan', 
                itemId: lpData.id, 
                itemValue: `${grade}_${name}`
              }) }}>{el.content}</p>
            })}
          </div>
        </div>

        {[...activityBookData, ...moreBookData].length > 0 && <div>
          <p className={`${baseClassName}__sub-title`}>{lpStaticData.booksUsed}</p>
          <LazyLoad offset={100} overflow>
            <HorizontalGrid cellWidth="book-card" id={"book-used"} isRtl={isRtl}>
              {
                [...activityBookData, ...moreBookData].map(book => {
                  return <BookCard 
                      key={book.id} 
                      book={book}
                      hideMenu
                      hideQuickViewBtn={true}
                      hideAllIcons = {true}
                      readSource={"stem"}
                      onTriggerEvent={() => triggerEvents({
                        gaAction: "clicked_book",
                        gtmLabel: 'side_menu',
                        itemType:'grade,lesson_plan', 
                        itemId: lpData.id, 
                        itemValue: `${grade}_${name}`
                      })}
                      originalAuthors={book.original_authors}
                      isRtl={isRtl}
                    />
              })
            }
            </HorizontalGrid>
          </LazyLoad>
        </div>}

        <Tags tags={stemLPTags.map(el => {
            return {name : el.tagName,
            query: el.tagName}
          })} 
          lpTag
          lang={locale}
          nonClickable={!online}
          baseClassName={baseClassName} 
          parentClassName={isRtl ? `${baseClassName}__tags ${baseClassName}__tags--rtl`: `${baseClassName}__tags`}
          userId={userId}
          userType={userType}
          eventCategory={gaEventCategories.stemLp}
          eventLabel={"explore_similar"} />


      </div>}
      {viewport.medium && <div className={`${baseClassName}__section-wrapper`}>
        <div className={`${baseClassName}__section-main`}>
          <div className={`${baseClassName}__banner`}>
            <img src={isMath ? stemImages.headerMaths : stemImages.headerScience} alt={'math'} className={`${baseClassName}__banner-image`}/>
          </div>
          <p className={`${baseClassName}__grade`}>{grade}</p>
          <h1 className={`${baseClassName}__title`}>{name}</h1>
          <div className={`${baseClassName}__section-secondary`}>
            {activityBookData.length > 0 && spotlightBook(activityBookData[0])}
            {learningsSection}
          </div>
        </div>
        {sectionArray}
        {footer}
      </div>}
      {
        showSection && !viewport.medium && sectionArray[activeIndex]
      }
      { !viewport.medium && 
        <FloatingActionsBar float={!viewport.large}>
          {showSection ?
            <div >
              <div className={`${baseClassName}__prg-wrapper`}>
                {contentArray.length > 0 && contentArray.map((el, ind) => <div className={activeIndex >= ind ? `${baseClassName}__prg ${baseClassName}__prg--done` : `${baseClassName}__prg`}></div>)}
              </div>
              <div className={`${baseClassName}__footer`}>
                <span></span>
                <div>
                  <span disabled={activeIndex <= 0} onClick={() => activeIndex > 0 && changeSection(-1)}>
                    <SvgIcon pushRight name={isRtl ? "chevron-right" :"chevron-left"} size="m" />
                  </span>
                  {isRtl ? <span className={`${baseClassName}__page`}>{sectionArray.length} / {activeIndex+1} </span> : <span className={`${baseClassName}__page`}>{activeIndex+1} / {sectionArray.length}</span>}
                  <span disabled={activeIndex >= sectionArray.length} onClick={() => activeIndex < sectionArray.length-1 && changeSection(1)}>
                    <SvgIcon pushLeft name={isRtl ? "chevron-left" :"chevron-right"} size="m" />
                  </span>
                </div>
                <span onClick={() => setSubMenu(!subMenu)}><SvgIcon name="menu" size="m"/></span>
              </div>
            </div>
            :
            <Button
              fullWidth
              rounded
              label={lpStaticData.getStarted}
              variant="primary"
              onClick={launchSection}
            />}
        </FloatingActionsBar>
      }
      {
        subMenu && !viewport.medium && <div className={isRtl ? `${baseClassName}__submenu--rtl ${baseClassName}__submenu` : `${baseClassName}__submenu`}>
          {contentArray.map((el, ind) => {
              return <p className={activeIndex === ind && !viewport.medium && `${baseClassName}__submenu--active`} 
              onClick={() => {scrollTo(el.id, ind); setSubMenu(false); window.scrollTo(0,0)}}>{el.content}</p>
            })}
        </div>
      }
      {
        isVideoPlayerVisible
          ?
          <StoryVideo
            onClose={onCloseVideo}
            videoId={video}
            csfModal
          />
          :
          null
        }
        {
            isModalVisible.noSpaceForMoreOfflineBooks
            ?
            <NoSpaceForMoreOfflineBooksModal
              viewport={viewport}
              onClose={() => onCloseModal('noSpaceForMoreOfflineBooks')}
              maximum={MAX_OFFLINE_BOOKS_COUNT}
              isRtl={isRtl}
            />
            :
            null
          }
          {
            isModalVisible.delete
            ?
            <DeleteModal
              onConfirm={() => onRemoveFromOfflineClicked(activeChunk)}
              onClose={() => onCloseModal('delete')}
              viewport={viewport}
              count={activeChunk.length}
              books={activeChunk}
              baseClassName={baseClassName}
              addSlimNotification={addSlimNotification}
              isRtl={isRtl}
              deleteQuestion={t('DeleteModalStem.title')}
              deleteSubInfo={t('DeleteModalStem.warning')}
              gaLabel={gaEventCategories.stem}
            />
            :
            null
          }
    </div>
  );
}

export default translate()(connect(mapStateToProps, mapDispatchToProps)(LessonPlanContainer));



// WEBPACK FOOTER //
// ./src/components/LessonPlanContainer/LessonPlanContainer.jsx